
import './App.css'
import './css/responsive.css'
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./store/store";
import Home from './Pages/Home';
import { Routes, Route } from 'react-router-dom';
import About from './Pages/About';
import Contact from './Pages/Contact';
import ShortTermLoan from './Pages/ShortTermLoan';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import TermandCondition from './Pages/TermandCondition';
import InstantPersonalLoan from './Pages/InstantPersonalLoan';
import EmergencyLoan from './Pages/EmergencyLoan';
import ApplyNow from './Pages/ApplyNow';
import PayNow from './Pages/PayNow';
import Layout from './Layout'
import ScrollToTop from '../src/component/ScrollTop'
import '@ant-design/v5-patch-for-react-19';
import ThankYou from './journey/Pages/thankyou/ThankYou';
import RepayThanku from './Pages/RepayThanku';

// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

import 'react-toastify/dist/ReactToastify.css';
// import NewDashboard from '../src/journey/Pages/NewDashboard';
// import ApplicationStep from '../journey/Pages/ApplicationStep';
// import UserDashboard from '../journey/Pages/UserDashboard';
// import LoanHistory from '../journey/Pages/LoanHistory';
// import LoanDetail from '../journey/Pages/LoanDetail';   
import NewDashboard from '../src/journey/Pages/Dashboard';
import ApplicationStep from '../src/journey/Pages/ApplicationStep';
import UserDashboard from '../src/journey/Pages/UserDashboard';
import LoanHistory from '../src/journey/Pages/LoanHistory';
import LoanDetail from '../src/journey/Pages/LoanDetail';
import Eplayout from './Eplayout';
import Support from './journey/Pages/Support';
import NotEligible from './journey/Pages/NotEligible';

function App() {
  return (
    <>
      <ScrollToTop />
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Routes>
              <Route path='/' element={<Eplayout/>}>
              <Route path='/' element={<Home />}></Route>
              <Route path='/about' element={<About />}></Route>
              <Route path='/short-term-loan' element={<ShortTermLoan />}></Route>
              <Route path='/instant-personal-loan' element={<InstantPersonalLoan />}></Route>
              <Route path='/emergency-loan' element={<EmergencyLoan />}></Route>
              <Route path='/contact' element={<Contact />}></Route>
              <Route path='/privacy-policy' element={<PrivacyPolicy />}></Route>
              <Route path='/terms-and-conditions' element={<TermandCondition />}></Route>
              <Route path='/thanku' element={<RepayThanku />}></Route>
              </Route>
            
            <Route path='/apply-now' element={<ApplyNow />}></Route>
            <Route path='/repay-loan' element={<PayNow />}></Route>
            
              
  
              <Route path='/' element={<Layout />}>
              <Route path="/journey" element={<NewDashboard />} />
              <Route path="/journey/application" element={<ApplicationStep />} />
              <Route path="/journey/dashboard" element={<UserDashboard />} />
              <Route path='/journey/loan-history' element={<LoanHistory />} />
              <Route path='/journey/loan-detail' element={<LoanDetail />} />
              <Route path='/journey/congratulations' element={<ThankYou />} /> 
              <Route path='/journey/support-detail' element={<Support/>} />
              <Route path='/journey/not-eligible' element={<NotEligible/>} />
               

            </Route>



          </Routes>

        </PersistGate>
      </Provider>



    </>
  );
}

export default App;
